export const flowGradeReportZH = {
  flowGradeReport1: '下载',
  flowGradeReport2: '暂无成绩报告',
  flowGradeReport3: '成绩报告',
  flowGradeReport4: '您已选择，无法更改',
  flowGradeReport5: '答题分析',
  flowGradeReport6: '活动任务',
  flowGradeReport7: '分数',
  flowGradeReport8: '题目数量:',
  flowGradeReport9: '道',
  flowGradeReport10: '答错:',
  flowGradeReport11: '未答:',
  flowGradeReport12: '用时:',
  flowGradeReport13: '答错',
  flowGradeReport14: '答对',
  flowGradeReport15: '未答',
  flowGradeReport16: '全部试题',
  flowGradeReport17: '正在计算成绩中，可能需要花费5分钟左右，请耐心等待~',
  flowGradeReport18: '刷新',
  flowGradeReport19: '分享到团队主页',
  flowGradeReport20: '分享到微信',
  flowGradeReport21: '成绩分数',
  flowGradeReport22: '你击败了全国 ',
  flowGradeReport23: ' 的人，继续加油哦！',
  flowGradeReport24: '排名将在',
  flowGradeReport25: '公布',
  flowGradeReport26: '分享成绩',
  flowGradeReport27: '用微信扫描二维码，分享成绩到微信/朋友圈',
  flowGradeReport28: '分',
  flowGradeReport29: '分',
  flowGradeReport30: '秒',
  flowGradeReport31: '我正在参加',
  flowGradeReport32: '我击败了全国 ',
  flowGradeReport33: '的人！',
  flowGradeReport34: '我完成了',
  flowGradeReport35: '，继续加油吧！',
  flowGradeReport36: '分享成功',
  flowGradeReport37: '报名参加',
  flowGradeReport38: '长按图片保存至相册分享',
  flowGradeReport39: '暂未公布哦~',
  flowGradeReport40: '答题分析还未公布哦~',
  flowGradeReport41: '公布时间',
  flowGradeReport42: '考试',
  flowGradeReport43: '正确答案',
  flowGradeReport44: '你的答案',
  flowGradeReport45: '解析',
  flowGradeReport46: '无',
  flowGradeReport47: '单选题',
  flowGradeReport48: '多选题',
  flowGradeReport49: '填空题',
  flowGradeReport50: '练习报告',
  flowGradeReport51: '答对题目数',
  flowGradeReport52: '再练习一次',
  flowGradeReport53: '击败全国'
}

export const flowGradeReportEN = {
  flowGradeReport1: 'Download',
  flowGradeReport2: 'No transcript',
  flowGradeReport3: 'Transcript',
  flowGradeReport4: `You've selected and can't change`,
  flowGradeReport5: 'Answer Analysis',
  flowGradeReport6: 'Activity Tasks',
  flowGradeReport7: 'Score',
  flowGradeReport8: 'Questions:',
  flowGradeReport9: '',
  flowGradeReport10: 'Wrong Answers:',
  flowGradeReport11: 'Not answered:',
  flowGradeReport12: 'Time:',
  flowGradeReport13: 'Wrong Answers',
  flowGradeReport14: 'Correct Answers',
  flowGradeReport15: 'Not answered',
  flowGradeReport16: 'All Questions',
  flowGradeReport17: 'The score is being calculated, it may take about 5 minutes, please be patient~',
  flowGradeReport18: 'Refresh',
  flowGradeReport19: 'Share to team homepage',
  flowGradeReport20: 'Share to WeChat',
  flowGradeReport21: 'Score',
  flowGradeReport22: `You've beaten `,
  flowGradeReport23: ' people of the country, keep going',
  flowGradeReport24: 'The rankings will be released on the day of',
  flowGradeReport25: '',
  flowGradeReport26: 'Share your achievements',
  flowGradeReport27: 'Scan the QR code with WeChat and share the results to WeChat/Moments',
  flowGradeReport28: 'points',
  flowGradeReport29: 'min',
  flowGradeReport30: 'sec',
  flowGradeReport31: `I'm participating in `,
  flowGradeReport32: 'I beat ',
  flowGradeReport33: ' people of the country!',
  flowGradeReport34: `I'm done `,
  flowGradeReport35: ', keep going!',
  flowGradeReport36: 'Share Success',
  flowGradeReport37: 'Registration',
  flowGradeReport38: 'Long press the image to save to album and share',
  flowGradeReport39: 'Not yet announced~',
  flowGradeReport40: 'answer analysis has not yet been announced~',
  flowGradeReport41: 'Announcement time',
  flowGradeReport42: 'Examination',
  flowGradeReport43: 'Correct Answer',
  flowGradeReport44: 'Your answer',
  flowGradeReport45: 'Answer Analysis',
  flowGradeReport46: 'None',
  flowGradeReport47: 'Single choice questions',
  flowGradeReport48: 'Multiple choice questions',
  flowGradeReport49: 'Fill-in-the-blank questions',
  flowGradeReport50: 'Activity report',
  flowGradeReport51: 'Number of questions answered correctly',
  flowGradeReport52: 'Practice again',
  flowGradeReport53: 'Those who beat the national '
}



// WEBPACK FOOTER //
// ./src/i18n/langs/flow/gradeReport.js